import { HelpCircle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

/**
 * A small "?" icon that pops a floating explainer. Use next to any field/column
 * label that isn't obvious. Keeps people on the page instead of jumping to /help.
 *
 * Usage:
 *   <HelpTip title="Derived Status">
 *     Statuses are computed from paperwork, pre-auth, and scheduling. You never
 *     manually set them — complete the underlying step and the status updates.
 *   </HelpTip>
 */
export default function HelpTip({ title, children, testid, side = 'top', size = 14 }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center w-5 h-5 rounded-full text-[#685B72]/70 hover:text-[#52475A] hover:bg-[#F1EDF5] transition-colors align-middle"
          data-testid={testid || 'help-tip'}
          aria-label={title ? `Help: ${title}` : 'Help'}
          onClick={(e) => e.stopPropagation()}
        >
          <HelpCircle size={size} strokeWidth={1.75} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-72 p-3.5 rounded-xl border border-[#E8E5EC] bg-white shadow-lg"
        side={side}
        sideOffset={6}
        data-testid={testid ? `${testid}-content` : 'help-tip-content'}
      >
        {title && (
          <div className="font-serif text-[13px] font-semibold text-[#2D2833] mb-1.5">
            {title}
          </div>
        )}
        <div className="text-xs text-[#685B72] leading-relaxed">{children}</div>
      </PopoverContent>
    </Popover>
  );
}
